export default function headerBurger() {
    const burger = document.querySelector(".header__burger-btn");
    const header = document.querySelector(".header");
    const overlay = document.querySelector('.overlay');
    var distance = 0;

    function disable_scroll() {
        document.querySelector("body").classList.add("dis-scroll");
        document.querySelector("body").scrollTo({
          top: distance,
          left: 0,
        });
    }

    function enable_scroll() {

        document.querySelector("body").classList.remove("dis-scroll");

        if ( distance != 0 ) {
            window.scrollTo({
                top: distance,
                left: 0,
            });
        }

    }

    burger?.addEventListener("click", (e) => {
        const isActive = header.classList.toggle("mobile-open");
        burger?.classList.toggle("burger-open");
        
        if (window.innerWidth <= 530) {
            overlay.classList.toggle('open');
            
            if (isActive) {
                //distance = window.scrollY;
                //disable_scroll();
            } else {
                //enable_scroll();
            }
        }
    })
    document.addEventListener('click', (e) => {
        if (!burger?.contains(e.target)) {
            burger?.classList.remove("burger-open");
            //enable_scroll();

            if (window.innerWidth <= 530) {
                overlay?.classList.remove('open');
            }
        }
    });
}

